export const styles = {
  color: "#FFFFFF",
  letterSpacing: 0.3,
  margin: 7,
  textTransform: "capitalize",
};
